import { Component, OnInit, ViewChild, TemplateRef, HostListener } from '@angular/core';
import { FormGroup, FormBuilder, FormArray } from '@angular/forms';
import { kpi, sla, filecontent, kpitarget, actionPlan, slaIssueList, actionPlanDetail, actionPlanDetailHistory } from './../../../models/slakpi';
import { division, user, department, targetMaster } from './../../../models/admin';
import { UtilityService } from './../../../services/utility.service';
import { SLAKPIApiService } from './../../../services/slakpi.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../../services/user.service';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,
  MenuCallbackArgs,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { formatDate } from '@angular/common';
import { ToasterService } from '../../../toaster.service';
import { EChartsOption } from 'echarts';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'action-plandetail',
  templateUrl: './action-plandetail.component.html',
  styleUrls: ['./action-plandetail.component.css']

})
export class ActionPlanDetailComponent implements OnInit {

  showMyContainer: boolean = false;
  public gridApi: any;
  public gridColumnApi: any;
  public columnDefs: any;
  public defaultColDef: any;
  public rowData: any;
  public PopoverModule;
  modalRef: BsModalRef;
  chartOption05: EChartsOption;
  @ViewChild('addtemplate', { static: false }) addtemplate: TemplateRef<any>;
  @ViewChild('addtemplateCoordinator', { static: false }) addtemplateCoordinator: TemplateRef<any>;
  @ViewChild('addMastertemplate', { static: false }) addmastertemplate: TemplateRef<any>;
  @ViewChild('CommentsDialog', { static: false }) commentstemplate: TemplateRef<any>;
  @ViewChild('PercentageDialog', { static: false }) percentagetemplate: TemplateRef<any>;
  @ViewChild('HistoryDialog', { static: false }) historyTemplate: TemplateRef<any>;

  headerTitle: string;
  @ViewChild('editSettingsTemplate', { static: false }) editSettingsTemplate: TemplateRef<any>;
  public defaultyear: number = 0;
  public selected_kpiUno: number = 0;
  public kpiTargetForm: FormGroup;
  public yearsArray: FormArray;
  public selected_schedule: number = 1;
  public submitClicked: boolean = false;

  columnDefinitions: Column[];
  gridOptions: GridOption;

  gridOptionsCopy: GridOption;
  columnDefinitionsCopy: Column[];
  dataset: any;
  public selTab = true;
  public data: any;
  public gridload: number = 0;
  public division_data: any;
  public department_data: any;
  public slaTypeUno_data: any;
  public target_data: any;
  public trend_data: any;
  public condition2_data: any;
  public slaStatusRule_data: any;
  public dataEntry_data: any;
  public user_data: any;
  public dataEntry_data_filter: any;
  public user_data_filter: any;
  public frequency_data: any;
  public selected_kpiCode: string = '';
  public editSettings: Object;
  public filterSettings: Object;
  public toolbar: string[];
  public pageSettings: Object;
  public formatoptions: Object;
  public orderData: object;
  public kpiData: object[];
  public kpiForm: FormGroup;
  submitted: boolean = false;

  invalid: boolean = false;
  public loading: boolean = true;
  public pageAction: string = 'add';
  isShow = false;
  public uploadedFiles: Array<File> = [];


  public permission: number = 1;
  public divisionUno_filter: number = 0;
  public checkbox_filter: boolean = false;
  //for Users Permission
  public permision_add: boolean = false;
  public permision_edit: boolean = false;
  public permision_delete: boolean = false;
  objActionPlan: any = new actionPlanDetail();
  objActionPlanMaster: any = new actionPlan();
  objSLA: any = new sla();
  user: any = {};
  login_UserID: string; // number
  isAdmin: boolean = false;
  angularGrid: AngularGridInstance;
  //For Filter
  backupCompletion: any;

  public sli_data: any;

  SLAno: string;
  AttachmentList: any;
  fileItemCount: any;
  fileContent: any;
  searchText: string;
  dataSearch: any;
  noDataImg: any;
  tenantUno: any;
  slaIssuelist_Kpi: any;
  kpiUno: any;
  AcPlanID: any;
  AcPlanKpiUno: any;
  historyGrid: AngularGridInstance;
  CopyGrid: AngularGridInstance;
  gridOptionsHistory: GridOption;
  datasetHistory: any;
  columnHistoryDefinitions: Column[];
  acDescription: any;
  acCode: any;
  data1: any;
  kpiName: any;
  isShowHistory: boolean = false;
  isOpenMaster: boolean = false;
  mindate: any;
  issueDescription: any;

  isCompletion: any;
  completionComment: any;
  isCompletionvalue: boolean = false;
  completionCommentValue: any;
  //isSLACordinator: boolean = false;
  actionCompletion: any;

  data2: any = [];
  dataset1: any = [];
  dataSearch1: any = [];
  actionCopyData: any = [];

  loading1: boolean = false;
  masterStartDate: any;
  masterEndDate: any;

  strStartDate: any;
  strEndDate: any;

  isCommentEntered: boolean = false;
  CommentEntered: any;
  public quarterUno?: number;
  public yearUno?: number;
  constructor(private formBuilder: FormBuilder, private _activatedRoute: ActivatedRoute, public restApi: SLAKPIApiService, private toaster: ToasterService, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    //To Validate User Permission
    this.mindate = this.utilityService.getCurrentdate();
    this.user = this.userService.getUserInfo();
    this.login_UserID = this.user.id;
    this.noDataImg = this.utilityService.getnodataImage();
    this.tenantUno = this.user.tenantUno;
    this.defaultyear = this.user.currentYear;
    this.quarterUno = this.user.currentQuarter;
    this.yearUno = this.defaultyear;
    this.isAdmin = (this.user.role == 'Administrator' || this.user.role == 'SLA Admin' || this.user.role == 'DDAdmin' || this.user.role == 'DDAdminReadonly' ) ? true : false;
    if (!this.isAdmin) {
      this.CheckUserPermission();
    } else {
      this.permision_add = true;
      this.permision_edit = true;
      this.permision_delete = true;
    }
    //this.loadHistory(1);
    this._activatedRoute.queryParams.subscribe((params: Params) => {
      
      if (params['actionPlanId'] != null) {
        this.objActionPlan.actionPlanID = Number(params['actionPlanId']);
        this.AcPlanID = Number(params['actionPlanId']);

        // this.loadActionPlanDetail()
      }
      if (params['actionCode'] != null) {
        this.objActionPlan.actionPlanCode = (params['actionCode']);
        this.acCode = (params['actionCode']);

      }
      if (params['actionBrief'] != null) {
        this.objActionPlan.actionPlanBrief = (params['actionBrief']);
        this.acDescription = (params['actionBrief']);

      }
      if (params['kpiuno'] != null) {
        this.objActionPlan.kpiUno = (params['kpiuno']);
        this.AcPlanKpiUno = (params['kpiuno']);
      }
    });
  }



  ngOnInit() {
    this.objActionPlan.completion = 0;
    this.userService.CheckLogin();
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: false,
      //frozenColumn: 3,


    };

    this.gridOptionsHistory = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,

      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'myTabContent',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: false,

    };

    this.gridOptionsCopy = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 100
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-copygrid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: false,
      //frozenColumn: 3,


    };

    this.loadActionPlanDetail();
    this.getDivisions();
    this.getSLAType();
    //this.getUsers();
    this.loadSlaIssueList(5);
    this.setColnDefn()
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  angularCopyGridReady(angularGrid: AngularGridInstance) {
    this.CopyGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  CheckUserPermission() {

    let userPermissionData = this.userService.getUserRights("SLA Issue List");
    if (userPermissionData != null && userPermissionData != undefined && userPermissionData.length > 0) {
      if (userPermissionData[0].showPage == 1) {
        this.permision_add = (userPermissionData[0].showAdd == 1) ? true : false;
        this.permision_edit = (userPermissionData[0].showEdit == 1) ? true : false;
        this.permision_delete = (userPermissionData[0].showDelete == 1) ? true : false;


      }
      else {
        this.router.navigateByUrl('/access-denied');
      }
    }
    else {
      this.router.navigateByUrl('/access-denied');
    }
  }

  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)


  }


  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' '

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' '

  }
  searchGrid() {
    
    if (this.searchText != "") {
      this.dataset = this.dataSearch.filter(a =>
        a.slaReference && a.slaReference.toLowerCase().includes(this.searchText.toLowerCase())
        || (a.slaNameEn && a.slaNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.slaTypeNameEn && a.slaTypeNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.reportingAccName && a.reportingAccName.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.businessAccNameEn && a.businessAccNameEn.toLowerCase().includes(this.searchText.toLowerCase()))
        || (a.fSignOffDate && a.fSignOffDate.toLowerCase().includes(this.searchText.toLowerCase()))
      );
    }
    else
      this.dataset = this.dataSearch;
  }
  setColnHistoryDefn() {
    let temp = this;
    this.columnHistoryDefinitions = [
      //{
      //  id: 'actionPlanDetailID', name: 'ID', field: 'actionPlanDetailID', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'actionPlanDetailID', 'actionPlanDetailID'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'actionPlanName', name: 'Action', field: 'actionPlanName', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.actionPlanName;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'actionPlanName', 'actionPlanName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'accountablityName', name: 'Accountability', field: 'accountablityName', sortable: true,
        width: 100,type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.accountablityName;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'accountablityName', 'accountablityName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'startDate', name: 'Start', field: 'startDate', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'Start', 'Start'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'endDate', name: 'End', field: 'endDate', selectable: false,
        width: 75,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'endDate', 'endDate'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'completion', name: '% Complete', field: 'completion',
        width: 100,
        sortable: true, type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.completion;
          return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'completion', 'completion'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'modifiedby', name: 'Modified By', field: 'modifiedby', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'modifiedby', 'modifiedby'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'modifiedOn', name: 'Modified On', field: 'modifiedOn', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'modifiedOn', 'modifiedOn'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'comment', name: 'Comment', field: 'comment', sortable: true,
        width: 100,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data1) => {
          let per = data1.comment;
          return '<div title="' + per + '">' + per + '</div>'
          // return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.datasetHistory, 'comment', 'comment'),
          model: Filters.multipleSelect,
        }
      },






    ]


  }

  setColnDefnActionCopy() {
    let temp = this;
    this.columnDefinitionsCopy = [
      
      {
        id: 'kpiNameEn', name: 'KPI', field: 'kpiNameEn', sortable: true, type: FieldType.string, filterable: true,
        minWidth: 300,
        filter: {
          collection: this.uniqueArray(this.dataset1, 'kpiNameEn', 'kpiNameEn'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'issueDescription', name: 'Issue Description', field: 'issueDescription', sortable: true, type: FieldType.string, filterable: true,
        minWidth: 300,
        filter: {
          collection: this.uniqueArray(this.dataset1, 'issueDescription', 'issueDescription'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'reportedDate', name: 'Reported Date', field: 'reportedDate', sortable: true, type: FieldType.string, filterable: true,
        minWidth: 300,
        filter: {
          collection: this.uniqueArray(this.dataset1, 'reportedDate', 'reportedDate'),
          model: Filters.multipleSelect,
        }
      },
     

    ]


  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [
      //{
      //  id: 'actionPlanDetailID', name: 'ID', field: 'actionPlanDetailID', sortable: true,
      //  type: FieldType.string, filterable: true,
      //  filter: {
      //    collection: this.uniqueArray(this.dataset, 'actionPlanDetailID', 'actionPlanDetailID'),
      //    model: Filters.multipleSelect,
      //  }
      //},
      {
        id: 'actionPlanName', name: 'Action', field: 'actionPlanName', sortable: true,
        width: 40,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.actionPlanName;
          //let dataset = "' " + per +"' "
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'actionPlanName', 'actionPlanName'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'accountablityName', name: 'Accountability', field: 'accountablityName', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.accountablityName;
          //let dataset = "' " + per +"' "
          return '<div title="' + per + '">' + per + '</div>'
          //return '<div title=' + per + ' class="visible visible-hover" >' + per + ' <span class="">' + per + '</span></div>'
          //return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'accountablityName', 'accountablityName'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'startDate', name: 'Start', field: 'startDate', sortable: true,
        width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'Start', 'Start'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'endDate', name: 'End', field: 'endDate', selectable: false,
        width: 50,
        type: FieldType.string, filterable: true,
        filter: {
          collection: this.uniqueArray(this.dataset, 'endDate', 'endDate'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'completion', name: '% Complete', field: 'completion', sortable: true,
        width: 50,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.completion;

          return '<div class="progress" style="height: 15px; font-size:9px; text-indent: 2px; background-color:#999;"><div class="progress-bar bg-d-green text-left" role = "progressbar" style = "width:' + per + '%;" aria-valuenow="' + per + '" aria-aluemin="0" aria - valuemax="100" > ' + per + '% </div></div>';

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'completion', 'completion'),
          model: Filters.multipleSelect,
        }
      },
      {
        id: 'comment', name: 'Comment', field: 'comment', sortable: true,
        width: 75,
        type: FieldType.string, filterable: true,
        formatter: (row, cell, val, columnDef, data) => {
          let per = data.comment;
          //let dataset = "' " + per +"' "
          return '<div title="' + per + '">' + per + '</div>'

        },
        filter: {
          collection: this.uniqueArray(this.dataset, 'comment', 'comment'),
          model: Filters.multipleSelect,
        }
      },

      {
        id: 'action', name: 'Action', field: 'action', cssClass: 'blue',
        maxWidth: 75,
        //width: 50,
        excludeFromExport: true,
        formatter: this.actionFormatter,
        cellMenu: {
          hideCloseButton: false,
          commandTitleKey: 'COMMANDS',
          commandItems: [
            {
              command: 'edit-row', titleKey: 'EDIT_ROW', positionOrder: 62, title: 'Edit',
              iconCssClass: 'fa fa-pencil-square-o', cssClass: 'blue', textCssClass: 'bold',
              itemVisibilityOverride: (args: MenuCallbackArgs) => {
                let data = args.dataContext;
                // this.objActionPlan = this.data.filter((items: any) => items.actionPlanDetailID == data.id)[0];
                
                if (this.user.role == 'SLA Coordinator') {
                  if (data.completion != 100) {
                    return true;
                  }
                  else {
                    return false;
                  }
                }
                else if (this.user.role == 'Administrator' || this.user.role == 'SLA Admin') {
                  return true;
                }
                else {
                  return false;
                }

                
              },
              action: (e, args) => {
                this.pageAction = 'edit';

                
                if (this.permission == 1) {
                  let rdata: any = args.dataContext;
                  //this.selTab = true;
                  //this.SLAno = rdata.id;
                  this.objActionPlan = this.data.filter((items: any) => items.actionPlanDetailID == rdata.id)[0];

                  this.objActionPlan.accountablity = (this.objActionPlan.accountablity) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objActionPlan.accountablity.toString()) : [];
                  //this.objActionPlan.startDate = formatDate(this.objActionPlan.startDate, 'yyyy-MM-dd', 'en-US');
                  //this.objActionPlan.endDate = formatDate(this.objActionPlan.endDate, 'yyyy-MM-dd', 'en-US');
                  //this.objActionPlan.startDate = formatDate(this.objActionPlan.startDate, 'yyyy/MM/dd', 'en-US');

                  this.objActionPlan.startDate = formatDate(this.objActionPlan.startDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.endDate = formatDate(this.objActionPlan.endDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.backupCompletion = this.objActionPlan.completion;
                  this.isCompletion = false;
                  this.isCompletionvalue = false;
                  
                  if (this.objActionPlan.completion != 100 && this.user.role == 'SLA Coordinator')
                    this.modalRef = this.modalService.show(
                      this.addtemplateCoordinator, //commentstemplate
                      Object.assign({}, {
                        class: 'gray modal-lg',
                        backdrop: true,
                        keyboard: true,
                        focus: true,
                        show: false,
                        ignoreBackdropClick: true,
                        animated: true
                      })
                    );
                  else if (this.user.role == 'Administrator' || this.user.role == 'SLA Admin')
                    this.modalRef = this.modalService.show(
                      this.addtemplate, //commentstemplate
                      Object.assign({}, {
                        class: 'gray modal-lg',
                        backdrop: true,
                        keyboard: true,
                        focus: true,
                        show: false,
                        ignoreBackdropClick: true,
                        animated: true
                      })
                    );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            {
              command: 'delete-row', titleKey: 'DELETE_ROW', positionOrder: 64, title: 'Delete',
              iconCssClass: 'fa fa-trash', cssClass: 'red', textCssClass: 'bold',
              action: (e, args) => {
                Swal.fire({
                  title: 'Delete',
                  text: 'Please confirm to delete the record',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ok',
                  cancelButtonText: 'Cancel'
                }).then((result) => {
                  if (result.value) {
                    this.pageAction = 'delete';
                    this.DeleteActionPlanDetail(args.dataContext);
                  } else if (result.dismiss === Swal.DismissReason.cancel) {

                    this.loadActionPlanDetail();
                  }
                })
              },
              // only show command to 'Delete Row' when the task is not completed

            },

            {
              command: 'comments', titleKey: 'comments', positionOrder: 62, title: 'Add Comments',
              iconCssClass: 'fa fa-comments', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                if (this.permission == 1) {
                  let rdata: any = args.dataContext;
                  //this.selTab = true;
                  //this.SLAno = rdata.id;
                  this.pageAction = 'Add Comments';
                  this.objActionPlan = this.data.filter((items: any) => items.actionPlanDetailID == rdata.id)[0];
                  this.objActionPlan.accountablity = (this.objActionPlan.accountablity) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objActionPlan.accountablity.toString()) : [];
                  //this.objActionPlan.startDate = formatDate(this.objActionPlan.startDate, 'yyyy-MM-dd', 'en-US');
                  //this.objActionPlan.endDate = formatDate(this.objActionPlan.endDate, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.startDate = formatDate(this.objActionPlan.startDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.endDate = formatDate(this.objActionPlan.endDateFormat, 'yyyy-MM-dd', 'en-US');

                  this.modalRef = this.modalService.show(
                    this.commentstemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'updatePercentage', titleKey: 'updatePercentage', positionOrder: 62, title: 'Update Percentage',
              iconCssClass: 'fa fa-percent', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                if (this.permission == 1) {
                  let rdata: any = args.dataContext;
                  //this.selTab = true;
                  //this.SLAno = rdata.id;
                  this.pageAction = 'Update Percentage';
                  this.objActionPlan = this.data.filter((items: any) => items.actionPlanDetailID == rdata.id)[0];
                  this.objActionPlan.accountablity = (this.objActionPlan.accountablity) ? this.utilityService.CommaSeperatorToArrayParseInt(this.objActionPlan.accountablity.toString()) : [];
                  //this.objActionPlan.startDate = formatDate(this.objActionPlan.startDate, 'yyyy-MM-dd', 'en-US');
                  //this.objActionPlan.endDate = formatDate(this.objActionPlan.endDate, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.startDate = formatDate(this.objActionPlan.startDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.objActionPlan.endDate = formatDate(this.objActionPlan.endDateFormat, 'yyyy-MM-dd', 'en-US');
                  this.backupCompletion = this.objActionPlan.completion;
                  this.isCompletion = false;
                  this.isCompletionvalue = false;
                  this.modalRef = this.modalService.show(
                    this.percentagetemplate,
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                }
              },
              // only show command to 'Delete Row' when the task is not completed

            },
            {
              command: 'history', titleKey: 'history', positionOrder: 62, title: 'View History',
              iconCssClass: 'fa fa-eye', cssClass: 'blue', textCssClass: 'bold',
              action: (e, args) => {
                if (this.permission == 1) {
                  this.isShowHistory = false;
                  let rdata: any = args.dataContext;
                  this.objActionPlan = this.data.filter((items: any) => items.actionPlanDetailID == rdata.id)[0];

                  this.isShowHistory = true;
                  this.modalRef = this.modalService.show(
                    this.historyTemplate, //commentstemplate
                    Object.assign({}, {
                      class: 'gray modal-lg',
                      backdrop: true,
                      keyboard: true,
                      focus: true,
                      show: false,
                      ignoreBackdropClick: true,
                      animated: true
                    })
                  );
                  //this.selTab = true;
                  //this.SLAno = rdata.id;
                  this.pageAction = 'ViewHistory';
                  this.loadHistory(this.objActionPlan.actionPlanDetailID);
                }
              }
            }

          ],
        }
      }




    ]


  }

  actionFormatter: Formatter = (row, cell, value, columnDef, dataContext) => {
    return `<div class="fake-hyperlink"> <i class="fa fa-ellipsis-h fa-lg"></i></div>`;
  };

  onSubmitComments() {
    
    if (this.objActionPlan.comment == null || this.objActionPlan.comment == '' ) {
      this.isCommentEntered = true;
      this.CommentEntered = 'Please Enter Comments';
    }
    else {
      this.isCommentEntered = false;
      this.AddEditSLA(this.objActionPlan)
    }
    
  }

  loadHistory(data) {
    this.spinner.show();
    let inpValue = new actionPlanDetailHistory();
    this.columnHistoryDefinitions = [];
    inpValue.languageUno = 1033;
    inpValue.actionPlanID = data;
    //inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    this.restApi.getActionPlanDetailHistory(inpValue)
      .subscribe(data => {
        this.data1 = [];
        this.datasetHistory = [];
        this.data1 = data //uniqBy(data, 'slaUno');
        const mockDataset = [];
        //this.objActionPlan.actionPlanCode = data[0].actionPlanCode;
        //this.objActionPlan.actionPlanBrief = data[0].actionPlanBrief;
        for (let i = 0; i < this.data1.length; i++) {
          mockDataset[i] = {
            id: this.data1[i].actionPlanHistoryID,
            actionPlanName: this.data1[i].actionPlanName,
            accountablity: this.data1[i].accountablity,
            accountablityName: this.data1[i].accountablityName,
            comment: this.data1[i].comment,
            //actionPlanCode: this.data[i].actionPlanCode,
            //actionPlanBrief: this.data[i].actionPlanBrief,
            completion: this.data1[i].completion,
            startDate: this.data1[i].startDate,
            endDate: this.data1[i].endDate,
            kpiUno: this.data1[i].kpiUno,
            modifiedby: this.data1[i].modifiedBy,
            modifiedOn: this.data1[i].modifiedOn
          };
        }
        this.datasetHistory = this.data1;
        //this.dataSearch = mockDataset;
        //this.dataset = this.data;
        //this.dataSearch = this.data;
        if (this.data1.length > 0) {
          this.setColnHistoryDefn();
        }
        this.datasetHistory = mockDataset;
        this.loading = false;
        this.spinner.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  openModalWithClassAction(addtemplate: TemplateRef<any>) {
    
    this.pageAction == "addMaster";
    this.uploadedFiles = [];
    this.objActionPlanMaster = new actionPlan();
    this.objActionPlanMaster.kpiUno = (this.AcPlanKpiUno) ? this.utilityService.CommaSeperatorToArrayParseInt(this.AcPlanKpiUno.toString()) : [];
    //this.objActionPlanMaster.kpiUno = this.AcPlanKpiUno;
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-medium',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );

  }



  onSubmitMaster(val) {
    
    if (!val) {
      //Swal.fire('Error', 'Please enter the General Information.', 'error');
      this.toaster.show('error', 'Please enter  Required Information.');
      this.selTab = true;
    }
    else {
      this.AddMaster(this.objActionPlanMaster)
    }
  }
  AddMaster(data1: any) {
    if (this.objActionPlanMaster.startDate > this.objActionPlanMaster.endDate) {
      /* Notiflix.Notify.failure('From date is not greater than to date', { timeout: 3000, position: 'right-bottom' });*/
      //Notiflix.Notify.failure('From Date cannot be greater than To Date', { timeout: 3000, position: 'right-bottom' });
      this.toaster.show('error', 'Error', 'Start Date cannot be greater than End Date');
      return false;
    }
    let filterInfo = this.userService.getFilterInfo();
    let quarterUno = filterInfo.quarterUno;
    let yearUno = filterInfo.yearUno;

    //let selectedDivisionData: any;
    //let divisionUno: any;
    //selectedDivisionData = this.slaIssuelist_Kpi.filter(a => a.kpiTrnUno.toString() == this.objActionPlanMaster.kpiUno.toString());
    //divisionUno = selectedDivisionData[0].divisionUno;
    //if (divisionUno.toString() != this.objActionPlanMaster.divisionUno.toString()) {
    //  this.toaster.show('error', 'Error', 'Please select KPI from same Division');
    //  return false;
    //}

    this.objActionPlanMaster.actionType = this.pageAction;
    this.objActionPlanMaster.actionPlanID = (this.pageAction == "addMaster") ? 0 : this.utilityService.isNumericNull(this.objActionPlanMaster.actionPlanID);
    this.objActionPlanMaster.userUno = this.login_UserID;
    this.objActionPlanMaster.tenantUno = this.tenantUno;
    this.objActionPlanMaster.kpiUno = (this.objActionPlanMaster.kpiUno) ? this.objActionPlanMaster.kpiUno.toString() : '';
    this.objActionPlanMaster.divisionUno = (this.objActionPlanMaster.divisionUno) ? this.objActionPlanMaster.divisionUno.toString() : '';
    this.objActionPlanMaster.yearUno = yearUno;
    this.objActionPlanMaster.quarterUno = quarterUno;
    let DivisionBackup = this.objActionPlanMaster.divisionUno;
    this.spinner.show();
    this.restApi.addEditActionPlan(this.objActionPlanMaster)
      .subscribe(data => {
        if (data == null && data != undefined && data != '' && (data.toString().indexOf('MSID_') <= 0)) {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
        else {
          if (data == '999') {
            this.toaster.show('error', 'Error', 'KPI already mapped to another Plan, please try other kpi');
            this.objActionPlanMaster.divisionUno = DivisionBackup;
          } else {
            this.AcPlanID = data;
            this.toaster.show('success', 'Success', 'Action Plan saved.');
            //Swal.fire({
            //  type: 'success',
            //  title: 'SLA saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            
            this.modalRef.hide();
            //this.SLAno = (this.pageAction == "add") ? data.toString() : this.SLAno;
            //this.uploadFiles();
            // this.loadActionPlan();
            this.isOpenMaster = false;
            this.loadActionPlanDetail();
          }
        }
        setTimeout(() => { this.spinner.hide(); this.loadActionPlanDetail(); }, 1100);
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
    //}
  }
  // Get ActionPlan list
  loadActionPlanDetail() {
    this.spinner.show();
    this.dataset = [];
    let inpValue = new actionPlanDetail();
    inpValue.languageUno = 1033;
    inpValue.actionPlanID = this.AcPlanID;
    //inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID
    inpValue.kpiUno = this.AcPlanKpiUno
    if (inpValue.actionPlanID) {
      inpValue.kpiUno = null;
    }

    this.restApi.getActionPlanDetail(inpValue)
      .subscribe(data => {
        debugger;
        //this.data = data //uniqBy(data, 'slaUno');
        const mockDataset = [];
        //if (this.data.length == 0 && this.AcPlanKpiUno != 0) {
        //  this.isOpenMaster = true
        //  //this.openModalWithClassAction(this.addmastertemplate);
        //}
        //else {
        //  this.isOpenMaster = false;
        //} 
        let listActionPlanMaster = data[0].listActionPlanMaster
        let listActionPlanKPI = data[0].list_ActionPlanCopy;

        //if (this.user.role == 'SLA Coordinator' && data[0].listActionPlanMaster.length == 0) {
        //  this.isSLACordinator = true;
        //}
        //else {
        //  this.isSLACordinator = false;
        //}
        this.actionCompletion = '0';
        if (listActionPlanMaster.length > 0) {
          
          this.isOpenMaster = false;
          this.acCode = data[0].listActionPlanMaster[0].actionPlanCode;
          this.objActionPlan.actionPlanCode = data[0].listActionPlanMaster[0].actionPlanCode;
          this.objActionPlan.actionPlanBrief = data[0].listActionPlanMaster[0].actionPlanBrief;
          this.acDescription = data[0].listActionPlanMaster[0].actionPlanBrief;
          this.kpiName = data[0].listActionPlanMaster[0].kpiNameEn;
          this.issueDescription = data[0].listActionPlanMaster[0].issueDescription;
          this.masterStartDate = data[0].listActionPlanMaster[0].masterStartDate;
          let StartDate = data[0].listActionPlanMaster[0].masterStartDate;
          this.strStartDate = (StartDate != "" && StartDate != null) ? formatDate(StartDate, 'dd-MM-yyyy', 'en-US') : "";

          this.masterEndDate = data[0].listActionPlanMaster[0].masterEndDate;
          let EndDate = data[0].listActionPlanMaster[0].masterEndDate;
          this.strEndDate = (EndDate != "" && EndDate != null) ? formatDate(EndDate, 'dd-MM-yyyy', 'en-US') : "";
          if (data[0].listActionPlanMaster[0].completion) {
            this.actionCompletion = data[0].listActionPlanMaster[0].completion;
          }
          else {
            this.actionCompletion = '0';
          }


          this.chartOption05 = {

            //tooltip: {
            //  trigger: 'item'
            //},
            color: ['#68b097', '#d0e6de'],
            legend: {
              top: '5%',
              show: false,
              left: 'center'
            },
            series: [
              {
                name: 'Access From',
                type: 'pie',
                radius: ['45%', '80%'],
                avoidLabelOverlap: false,
                // label: {
                //   show: false,
                //   position: 'center'
                // },
                label: {

                  color: '#000',
                  fontSize: '30',
                  silent: true,
                  position: 'center',
                  formatter: () => {
                    // return "96%" // Use sum variable here
                    return (this.actionCompletion.toString() + '%');
                  },
                },
                // emphasis: {
                //   label: {
                //     show: false,
                //     fontSize: '40',
                //     fontWeight: 'bold'
                //   }
                // },
                labelLine: {
                  show: false
                },
                data: [
                  { value: this.actionCompletion },
                  { value: (100 - parseInt(this.actionCompletion)) },
                ]
                //data: data,
              }
            ]
          };

        }
        else {
          this.isOpenMaster = true;
        }
        this.data = data[0].listActionPlanDetail;
        for (let i = 0; i < this.data.length; i++) {
          if (this.data[i].completion == "") {
            this.data[i].completion = 0
          }
          mockDataset[i] = {
            id: this.data[i].actionPlanDetailID,
            actionPlanName: this.data[i].actionPlanName,
            accountablity: this.data[i].accountablity,
            accountablityName: this.data[i].accountablityName,
            comment: this.data[i].comment,
            //actionPlanCode: this.data[i].actionPlanCode,
            //actionPlanBrief: this.data[i].actionPlanBrief,
            completion: this.data[i].completion,
            startDate: this.data[i].startDate,
            endDate: this.data[i].endDate,
            kpiUno: this.data[i].kpiUno
          };
        }
        this.dataset = mockDataset;
        this.dataSearch = mockDataset;
        //this.dataset = this.data;
        //this.dataSearch = this.data;
        if (this.data.length > 0) {
          this.setColnDefn();
        }
        else {
          this.dataset = [];
        }
        this.kpiData = mockDataset;
        this.loading = false;

        //Action plan cpoied KPI Deatils
        const mockDataset1 = [];
        this.data2 = data[0].list_ActionPlanCopy;
        for (let i = 0; i < this.data2.length; i++) {
         
          mockDataset1[i] = {
            id: i+1,
            //id: this.data2[i].actionPlanDetailID,
            kpiNameEn: this.data2[i].kpiNameEn,
            issueDescription: this.data2[i].issueDescription,
            reportedDate: this.data2[i].reportedDate,
            //kpiUno: this.data1[i].kpiUno
          };
        }
        this.dataset1 = mockDataset1;
        this.dataSearch1 = mockDataset1;
        //this.dataset = this.data;
        //this.dataSearch = this.data;
        if (this.data2.length > 0) {
          this.setColnDefnActionCopy();
        }
        else {
          this.dataset1 = [];
        }
        this.actionCopyData = mockDataset;
        this.kpiData = mockDataset;
        this.loading1 = false;
        this.spinner.hide()

      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success q`  and error)
        this.spinner.hide();
      });
  }


  getDivisions() {

    let inpValue = new division();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getDivisions(inpValue)
      .subscribe(data => {

        this.division_data = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getSLAType() {

    let inpValue = new sla();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 1;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getSLATypes(inpValue)
      .subscribe(data => {
        this.slaTypeUno_data = data;

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getUsers() {

    let inpValue = new user();
    inpValue.userUno = this.login_UserID;
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = 0;
    inpValue.tenantUno = this.tenantUno;
    this.restApi.getUsers(inpValue)
      .subscribe(data => {
        
        this.user_data = data;
        this.dataEntry_data = data;
        this.user_data_filter = data;
        this.dataEntry_data_filter = data;
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }


  DeleteActionPlanDetail(data1: any) {

    let objDeaprtment = new actionPlanDetail();
    // objDeaprtment.actionType = this.pageAction;
    objDeaprtment.actionPlanDetailID = data1.id;
    objDeaprtment.userUno = this.login_UserID;
    objDeaprtment.tenantUno = 1;

    this.restApi.deleteActionPlanDetail(objDeaprtment)
      .subscribe(data => {

        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'Issue Action deleted.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'SLA deleted.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadActionPlanDetail();
        }


        //(this.postData);
        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

  }



  getFileIconClass(fileTitle: string) {

    if (fileTitle == '' || fileTitle == null)
      return "fa fa-file";

    var rtnClass = "fa fa-file";
    var strTitle = (fileTitle.indexOf('.') > 0) ? fileTitle.split('.')[1].toLowerCase() : 'unknown';

    switch (strTitle) {
      case 'txt':
        rtnClass = "fa fa-file-o";
        break;
      case 'doc':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'docx':
        rtnClass = "fa fa-file-word-o";
        break;
      case 'xls':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'xlsx':
        rtnClass = "fa fa-file-excel-o";
        break;
      case 'pdf':
        rtnClass = "fa fa-file-pdf-o";
        break;
      case 'gif':
      case 'jpeg':
      case 'jpg':
      case 'png':
        rtnClass = "fa fa-file-picture-o";
        break;
      case 'mp3':
        rtnClass = "fa fa-file-audio-o";
        break;
      case 'mp4':
      case 'mpeg':
      case 'mpg':
      case 'avi':
        rtnClass = "fa fa-file-video-o";
        break;
      default:
        rtnClass = "fa fa-file";
        break;
    }

    return rtnClass;

  }
  uploadFiles() {
    this.spinner.show();
    
    if (this.uploadedFiles.length > 5) {
      this.toaster.show('error', 'Error', 'Maximum 5 Files to be upload');
      return false;
    }
    for (var i = 0; i < this.uploadedFiles.length; i++) {
      let allowFile = false;
      let fileName = this.uploadedFiles[i].name.toLowerCase();
      let fileSize = this.uploadedFiles[i].size;
      //Check file size
      let allowFileSize = false;
      allowFileSize = this.userService.checkFileSize(fileSize);
      if (!allowFileSize) {
        this.toaster.show('error', 'Error', 'A file size should not above 30MB.');
        return;
      }
      //To check filee size exe  
      allowFile = this.userService.checkFileValuranabity(fileName, fileSize);

      if (allowFile) {
        this.restApi.SLAFileUpload(this.uploadedFiles[i], this.uploadedFiles[i].name, this.SLAno).subscribe(data => {

          this.spinner.hide();
        },
          (error) => {
            //Called when error
            // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
      }
    }
  }

  DuplicateNameCheck(slaUno: number, slaNameEn: string, slaNameAr: string) {
    if (this.data != null && this.data != undefined) {
      var rtnValue = false;
      this.data.forEach((grdData) => {

        if ((slaUno != grdData.slaUno) && (grdData.slaNameEn.toLocaleLowerCase() == slaNameEn.toLocaleLowerCase() || grdData.slaNameAr.toLocaleLowerCase() == slaNameAr.toLocaleLowerCase())) {
          rtnValue = true;
        }
      });

      return rtnValue;
    }
  }


  onClickAttachment(SLAno: string): void {
    
    this.getFiles(SLAno);
  }

  AddEditSLA(data1: any) {
    
    let masStartDate = formatDate(this.masterStartDate, 'yyyy-MM-dd', 'en-US');
    let masEndDate = formatDate(this.masterEndDate, 'yyyy-MM-dd', 'en-US');
    if (masStartDate <= this.objActionPlan.startDate && masEndDate >= this.objActionPlan.endDate) {
    if (this.objActionPlan.startDate > this.objActionPlan.endDate) {
        /* Notiflix.Notify.failure('From date is not greater than to date', { timeout: 3000, position: 'right-bottom' });*/
        //Notiflix.Notify.failure('From Date cannot be greater than To Date', { timeout: 3000, position: 'right-bottom' });
        this.toaster.show('error', 'Error', 'Start Date cannot be greater than End Date');
        return false;
      }
      else {
      this.objActionPlan.actionType = this.pageAction;

      this.objActionPlan.actionPlanID = this.AcPlanID;
      this.objActionPlan.actionPlanDetailID = (this.pageAction == "add") ? 0 : this.utilityService.isNumericNull(this.objActionPlan.actionPlanDetailID);
      this.objActionPlan.userUno = this.login_UserID;
      this.objActionPlan.tenantUno = this.tenantUno;
      this.objActionPlan.kpiuno = this.AcPlanKpiUno;

      this.objActionPlan.accountablity = (this.objActionPlan.accountablity) ? this.objActionPlan.accountablity.toString() : '';
      

      this.spinner.show();
      this.restApi.addEditActionPlanDetail(this.objActionPlan)
        .subscribe(data => {

          if (data == null && data != undefined && data != '' && (data.toString().indexOf('MSID_') <= 0)) {
            // Swal.fire('Error', 'Something went wrong', 'error')
            this.toaster.show('error', 'Error', 'Something went wrong.');
          }
          else {
            if (this.pageAction == 'Add Comments') {
              this.toaster.show('success', 'Success', 'Comments saved.');
            }
            else if (this.pageAction == 'Update Percentage') {
              this.toaster.show('success', 'Success', 'Percentage Updated.');
            }
            else {
              this.toaster.show('success', 'Success', 'Issue Action saved.');
            }

            //Swal.fire({
            //  type: 'success',
            //  title: 'SLA saved.',
            //  showConfirmButton: false,
            //  timer: 1500
            //})
            
            this.modalRef.hide();
            // this.SLAno = (this.pageAction == "add") ? data.toString() : this.SLAno;
            this.loadActionPlanDetail();
            //this.uploadFiles();
          }
          setTimeout(() => { this.spinner.hide(); this.loadActionPlanDetail(); }, 1100);
        },
          (error) => {
            //Called when error
            this.spinner.hide();
          }
        ).add(() => {
          //Called when operation is complete (both success and error)
          this.spinner.hide();
        });
    }
    }
    else {
      this.toaster.show('error', 'Error', 'Start Date and End Date should be between Action plan dates, Please update in Action');
    }
    //}
  }

  getFiles(slaUno: string) {
    this.AttachmentList = null;
    let inpValue = new filecontent();
    inpValue.masterUNo = slaUno;
    inpValue.itemUNo = '0';
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.SLAno = slaUno;
    this.restApi.SLA_FileSelect(inpValue)
      .subscribe(data => {
        this.AttachmentList = data;
        this.fileItemCount = (this.AttachmentList != undefined && this.AttachmentList != null) ? this.AttachmentList.length : 0;
        this.spinner.hide();

      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }

  DeleteAttachment(itemUno: string) {

    //});
    
    let inpValue = new filecontent();
    inpValue.masterUNo = this.SLAno;
    inpValue.itemUNo = itemUno;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_FileDelete(inpValue)
      .subscribe(data => {
        this.getFiles(this.SLAno);
        //setTimeout(() => { this.spinner.hide(); this.loadSLA(); }, 1100);
      },
        (error) => {
          this.spinner.hide();
        }
      ).add(() => {
        this.spinner.hide();
      });
  }
  AttachmentDownload(id: any, name: string) {
    let inpValue = new filecontent();
    inpValue.masterUNo = this.SLAno;
    inpValue.itemUNo = id;
    inpValue.userUno = this.login_UserID;
    this.spinner.show();
    this.restApi.SLA_Filedownload(inpValue).subscribe(
      data => {
        
        this.spinner.hide();
        if (data != null) {
          
          if (window.navigator.msSaveOrOpenBlob) //IE & Edge
          {
            //msSaveBlob only available for IE & Edge
            window.navigator.msSaveBlob(data, name);
          }
          else //Chrome & FF
          {
            var url = window.URL.createObjectURL(data);
            var a = document.createElement('a');
            document.body.appendChild(a);
            a.setAttribute('style', 'display: none');
            a.href = url;
            a.download = name;
            a.click();
            window.URL.revokeObjectURL(url);
            a.remove(); // remove the element
          }

        }
        else {
          this.spinner.hide();
          //Swal.fire('Error', 'Something went wrong', 'error');
          this.toaster.show('error', 'Error', 'Something went wrong.');
        }
      },
      error => {
        //Swal.fire('Error', 'Something went wrong', 'error')
        this.toaster.show('error', 'Error', 'Something went wrong.');
        this.spinner.hide();
      },
      () => {
        // 'onCompleted' callback.
        this.spinner.hide();

      }
    );

  }



  openModalWithClass(addtemplate: TemplateRef<any>) {
    this.isCompletion = false;
    this.isCompletionvalue = false;
    this.backupCompletion = 0;
    this.pageAction == "add";
    this.uploadedFiles = [];
    this.objActionPlan = new actionPlan();
    this.objActionPlan.completion = 0;
    this.selTab = true;
    this.modalRef = this.modalService.show(
      addtemplate,
      Object.assign({}, {
        class: 'gray modal-lg',
        backdrop: true,
        keyboard: true,
        focus: true,
        show: false,
        ignoreBackdropClick: true,
        animated: true
      })
    );
  }


  getBooleanValue(checkboxSelector) {
    return document.querySelector(checkboxSelector).checked;
  }
  onNext(val) {
    if (val) {
      this.selTab = false;
    }
    else {
      //Swal.fire('Error', 'Please enter the General Information.', 'error')
      this.toaster.show('error', 'Please enter Required Information.');
    }
  }
  onSubmit(val) {
    
    this.isCompletionvalue = false;
    this.isCompletion = false;
    if (!val) {
      //Swal.fire('Error', 'Please enter the General Information.', 'error');
      this.toaster.show('error', 'Please enter Required Information.');
      this.selTab = true;
      this.isCompletion = false;
      this.isCompletionvalue = false;
    }
    else if (this.objActionPlan.completion < this.backupCompletion) {
      this.isCompletionvalue = false;
      this.isCompletion = true;
      this.completionComment = 'Completion percentage should not be less than previous one (' + this.backupCompletion + ').';
      return false;
    }
    else if (this.objActionPlan.completion >100) {
      this.isCompletionvalue = true;
     
      this.completionCommentValue = 'Completion percentage should not be greater than 100';
      return false;
    }

    else {
      this.isCompletionvalue = false;
      this.isCompletion = false;
      this.AddEditSLA(this.objActionPlan)
    }
  }

  createFormGroup(data1: any) {

    this.kpiTargetForm = this.formBuilder.group({
      kpiUno: '',
      yearsArray: this.formBuilder.array([])
    });
  }
  createyearItem(objkpitarget: kpitarget): FormGroup {
    
    return this.formBuilder.group({
      kpiUno: objkpitarget.kpiUno,
      kpiYear: objkpitarget.kpiYear,
      kpiYear_Text: objkpitarget.kpiYear_Text,
      frequency: objkpitarget.frequency,
      kpitarget1: objkpitarget.kpitarget1,
      kpitarget2: objkpitarget.kpitarget2,
      kpitarget3: objkpitarget.kpitarget3,
      kpitarget4: objkpitarget.kpitarget4,
      kpitarget5: objkpitarget.kpitarget5,
      kpitarget6: objkpitarget.kpitarget6,
      kpitarget7: objkpitarget.kpitarget7,
      kpitarget8: objkpitarget.kpitarget8,
      kpitarget9: objkpitarget.kpitarget9,
      kpitarget10: objkpitarget.kpitarget10,
      kpitarget11: objkpitarget.kpitarget11,
      kpitarget12: objkpitarget.kpitarget12,
      kpitarget13: objkpitarget.kpitarget13
    });
  }
  addItem(kpiuno, Frequency): void {
    this.yearsArray = this.kpiTargetForm.get('yearsArray') as FormArray;
    this.spinner.show();
    let inpValue = new kpitarget();
    inpValue.languageUno = 1033;
    inpValue.kpiUno = kpiuno;
    inpValue.kpiYear = this.defaultyear;
    inpValue.frequency = Frequency;
    inpValue.itemUno = 2;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    
    this.restApi.getKpiTargets(inpValue)
      .subscribe(kpidata => {

        let objkpidata: any = kpidata;
        if (objkpidata != null && objkpidata.length > 0)
          for (var i = 0; i < 7; i++) {
            
            this.yearsArray.push(this.createyearItem(kpidata[i]));
          }

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });


  }


  AddEditKPITarget(data1: any) {
    if (this.kpiTargetForm == null || this.kpiTargetForm.invalid) {
      // Swal.fire('Error', 'Something went wrong', 'error')
      this.toaster.show('error', 'Error', 'Something went wrong');
      return false;
    }

    
    let objKPITarget = new kpitarget();

    objKPITarget.listkpiTarget = data1.yearsArray;
    objKPITarget.userUno = this.login_UserID;
    objKPITarget.kpiYear = this.defaultyear;
    objKPITarget.kpiUno = this.selected_kpiUno;
    objKPITarget.condition = 1;//(this.pageAction == "add") ? 0 : 1;
    objKPITarget.tenantUno = this.tenantUno;
    objKPITarget.foreCastType = 2;
    
    this.restApi.addKpiTarget(objKPITarget)
      .subscribe(data => {
        
        if (data != null && data != undefined && data != '') {
          // Swal.fire('Error', 'Something went wrong', 'error')
          this.toaster.show('error', 'Error', 'Something went wrong');
        }
        else {
          this.toaster.show('success', 'Success', 'SLA Target Saved.');
          //Swal.fire({
          //  type: 'success',
          //  title: 'KPI Target Saved.',
          //  showConfirmButton: false,
          //  timer: 1500
          //})
          this.loadActionPlanDetail();
        }

        this.modalRef.hide();

        this.spinner.hide();
      },
        (error) => {
          //Called when error
          this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });

    return true;

  }

  saveTarget() {
    this.submitClicked = true;
    if (this.kpiTargetForm.valid) {
      this.AddEditKPITarget(this.kpiTargetForm.value);
    }
  }

  onchangeKpi(e) {
    //

    //alert(e.itemData.slaUno);
    //this.slaUno = (e && e.length > 0) ? e[0].value : 0;
    this.loadSlaIssueList(5);

  }
  // Get SlaIssueList list
  loadSlaIssueList(condition) {
    debugger;
   
    //this.spinner.show();
    if (localStorage.getItem('strFilter')) {
      let strFilter = JSON.parse(localStorage.getItem('strFilter'));
      if (strFilter.quarterUno != undefined) {
        this.quarterUno = Number(strFilter.quarterUno);
      }
      if (strFilter.yearUno != undefined) {
        this.yearUno = Number(strFilter.yearUno);
      }
    }
    let inpValue = new slaIssueList();
    inpValue.languageUno = 1033;
    inpValue.itemUno = 0;
    inpValue.condition = condition;
    inpValue.tenantUno = this.tenantUno;
    inpValue.userUno = this.login_UserID;
    //inpValue.slaUno = this.slaUno ? this.slaUno : 0;
    inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    //inpValue.slaUno = this.slaUno ? this.slaUno : 0;
    //inpValue.kpiyear = this.yearUno ? this.yearUno : 0;
    //inpValue.kpiquarter = this.quarterUno ? this.quarterUno : 0;
    //inpValue.divisionUno = this.divisionUno ? this.divisionUno : 0;
    //inpValue.frequencyUno = this.frequencyUno ? this.frequencyUno : 0;
    //inpValue.half = this.currentHalf;
    //inpValue.month = this.currentMonth;
    this.restApi.getSlaIssueList(inpValue)
      .subscribe(data => {
        
        this.slaIssuelist_Kpi = [];
        if (data != null && data != undefined) {
          let kpiList: any = [];
          kpiList = data;

          const mockDataset = [];
          for (let i = 0; i < kpiList.length; i++) {
            mockDataset[i] = {
              kpiTrnUno: kpiList[i].kpiTrnUno,
              kpiName: kpiList[i].kpiName,
              kpiCode: kpiList[i].kpiCode,
              displayName: kpiList[i].kpiCode + ' : ' + kpiList[i].kpiName,
              divisionUno: kpiList[i].divisionUno,
              businessDivisionUno: kpiList[i].businessDivisionUno,
              reportingDivisionUno: kpiList[i].reportingDivisionUno
            }
          }
         // this.slaIssuelist_Kpi = mockDataset;
         
          if (!this.isAdmin) {
            this.slaIssuelist_Kpi = mockDataset.filter(a =>
              (a.businessDivisionUno.toString() == this.user.divisionUno.toString()));
            //|| (a.reportingDivisionUno.toString() == this.user.divisionUno.toString())
          }
          else {
            this.slaIssuelist_Kpi = mockDataset;
          }

         
        }

      },
        (error) => {
          //Called when error
          //this.spinner.hide();
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
        this.spinner.hide();
      });
  }

  historyGridReady(angularGrid: AngularGridInstance) {
    this.historyGrid = angularGrid;
  }

  backtoPrevious() {
    if (this.AcPlanKpiUno) {
      this.router.navigate(['dashboard-issueactionplan'])
    }
    else {
      this.router.navigate(['dashboard-actionplan'])
    }
  }

  onSubmitPercentage() {
    
    if (this.objActionPlan.completion < this.backupCompletion) {
      this.isCompletionvalue = false;
      this.isCompletion = true;
      this.completionComment = 'Completion percentage should not be less than previous one (' + this.backupCompletion + ').';
      return false;
    }
    else if (this.objActionPlan.completion > 100) {
      this.isCompletionvalue = true;
      this.isCompletion = false;
      this.completionCommentValue = 'Completion percentage should not be greater than 100';
      return false;
    }

    else {
      this.isCompletionvalue = false;
      this.isCompletion = false;
      this.AddEditSLA(this.objActionPlan)
    }
   
  }
}
